export class ConditionService {
  findTargetGroups(group: any[], potentialTargets, parentGroupIndex = '0') {
    potentialTargets.push({
      name: 'Gruppe ' + parentGroupIndex,
      conditions: group
    });
    let prefix = parentGroupIndex === '0' ? '' : parentGroupIndex + '.';
    let counter = 1;
    group.forEach((subCondition) => {
      if (subCondition.conditions) {
        this.findTargetGroups(subCondition.conditions, potentialTargets, prefix + counter);
        counter++;
      }
    });
  }

  addGroupNames(condition, parentGroupIndex = '0') {
    let prefix = parentGroupIndex === '0' ? '' : parentGroupIndex + '.';
    let counter = 1;
    condition.$$groupName = 'Gruppe ' + parentGroupIndex;
    if (condition.conditions) {
      condition.conditions.forEach((c) => {
        if (c.conditions) {
          this.addGroupNames(c, prefix + counter);
          counter++;
        }
      });
    }
  }
}
